export const formatDecimal = (input?: number, fixed = 2, del = ",") => {
  return (input || 0).toFixed(fixed).replace(".", del);
};

export const formatPrice = (input?: number, delimiter = ",") => {
  return input || input === 0
    ? `${input.toFixed(2).replace(".", delimiter)} €`
    : "N/A";
};
